// src/utils/routeHelpers.js
export function withCountryPrefix(path, country) {
  if (!country) return path;
  // αφαίρεσε αρχικό slash αν υπάρχει
  const clean = path.startsWith("/") ? path.slice(1) : path;
  return `/${country}/${clean}`;
}

